// Sanitiser for the static Label/Value option editor, extracted so the rule
// below can be tested without mounting the whole admin page.

// cleanOptions drops half-typed rows and normalises what the option editor
// writes.
//
// `module` needs the care. It is optional, and an empty string is NOT the same
// as absent: blank means "this option uses the form's own module", which the
// consumer expresses by falling back when the key is missing. Storing "" would
// leave every option of every form carrying a meaningless key, and the next
// person reading the document could not tell a deliberate blank from an
// untouched field.
export function cleanOptions(options) {
  return (options ?? [])
    .filter((option) => option?.label || option?.value)
    .map((option) => {
      const next = { ...option };
      const module = String(next.module ?? '').trim();
      if (module) next.module = module;
      else delete next.module;
      return next;
    });
}

export default cleanOptions;
